import { render, staticRenderFns } from "./CompraDividaList.vue?vue&type=template&id=55b99f2a&"
import script from "./CompraDividaList.vue?vue&type=script&lang=js&"
export * from "./CompraDividaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports